import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGO_SRC } from 'lib/site';
interface LogoProps {
    width?: number;
    height?: number;
    showText?: boolean;
}
export const Logo: React.FC<LogoProps> = ({ width = 24, height = 24, showText = true }) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    // Brand click returns the user to the home of whichever shell they're in:
    // staff app, candidate portal, or the public marketing root.
    const home = pathname.startsWith('/app') ? '/app' : pathname.startsWith('/portal') ? '/portal' : '/';
    const badgeStyle = { width: width + 8, height: height + 8 };
    return (<Link to={home} className="flex items-center space-x-2 text-black dark:text-white">
      {/* Lime tile with black ink is the logo on every theme; it carries its own rounded corners. */}
      <span className="inline-flex shadow-lg shadow-black/10 rounded-[22%]" style={badgeStyle}>
        <img src={LOGO_SRC} alt={t('examing')} className="block h-full w-full"/>
      </span>
      {/* Plus Jakarta Sans (font-display): its round geometric forms echo the rounded tile and the looping mark. 800 is the heaviest weight loaded. */}
      {showText && (<span className="font-display text-[22px] font-extrabold leading-none tracking-[-0.03em]">{t("examing")}</span>)}
    </Link>);
};
export default Logo;
